/**
 * @generated SignedSource<<d1e3704539c8e5a49c975bc516072bda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreloadedCheckoutDuties_shipmentQuote$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteDutiesDescription_shipmentQuote">;
  readonly " $fragmentType": "PreloadedCheckoutDuties_shipmentQuote";
};
export type PreloadedCheckoutDuties_shipmentQuote$key = {
  readonly " $data"?: PreloadedCheckoutDuties_shipmentQuote$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreloadedCheckoutDuties_shipmentQuote">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreloadedCheckoutDuties_shipmentQuote",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteDutiesDescription_shipmentQuote"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "e2a9261d8db5c6c9993f5364d597ae05";

export default node;
